export async function initRecaptcha(callback: Function) {
    const script = document.createElement("script")
    script.onload = (e) => {        
        const grecaptcha = window['grecaptcha']
        if (!grecaptcha) return
        grecaptcha.ready(async () => {
            const token = await grecaptcha.execute(process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITEKEY)
            await callback(token)
            document.body.removeChild(script)
        })
    }
    script.src = "https://www.google.com/recaptcha/api.js?render=" + process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITEKEY
    script.async = false

    document.body.appendChild(script)
}